import { useEffect } from 'react';
import { SITE } from '../content/site';
import type { Locale, PageId } from './locale';

/**
 * Development parity for the localized <head>: production pages are prerendered with title,
 * description, canonical and hreflang (src/seo.ts); the dev server serves the bare template, so the
 * title and description are applied on the client when missing.
 */
export function useDocumentMeta(page: PageId, locale: Locale) {
  useEffect(() => {
    const meta = SITE[locale].meta[page];
    if (!document.title) document.title = meta.title;
    if (!document.querySelector('meta[name="description"]')) {
      const tag = document.createElement('meta'); tag.name = 'description'; tag.content = meta.description; document.head.append(tag);
    }
  }, [page, locale]);
}
